import React from 'react';
import './App.css';
import WeatherPage from './components/WeatherPage';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">MANU WEATHER APP</header>
      <WeatherPage />
    </div>
  );
}

export default App;
